import { useState, useCallback } from "react";
import { Modal, Col, Row, Form } from "react-bootstrap";
import IcX from "../../components/Svg/IcX";
import styles from "./style.module.css";
import Button from "../Button";
import { useDropzone } from "react-dropzone";
import { File } from "../Input";
import api from "../../services/api";
import useWrapper from "../../hooks/useWrapper";
import { toast } from "react-toastify";

export default function ModalConfirmPayment(props) {
  const { payment_id, show, closeModal: closeModalProps, reload, setReload, user_id } = props;
  const [loading, setloading] = useState(false);
  const { me, config, token } = useWrapper();

  const [filePayment, setfilePayment] = useState([]);
  const onDropFilePayment = useCallback(files => {
    setfilePayment(
      files.map(e =>
        Object.assign(e, {
          preview: URL.createObjectURL(e),
        }),
      ),
    );
  }, []);
  const { getRootProps: getRootPropsfileRG, getInputProps: getInputPropsfileRG } = useDropzone({
    accept: "image/*",
    multiple: false,
    maxFilesize: 20971520, // 20 MB
    onDrop: onDropFilePayment,
  });

  const confirmPayment = async () => {
    setloading(true);
    let _file = null;
    let _body = null;
    if (filePayment.length > 0) {
      _body = new FormData();
      _body.append("file", filePayment[0]);
      _file =
        filePayment.length &&
        (await api.post("files", _body, {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
            rg: 1,
            proof: 0,
          },
        }));
    }

    await api.put(
      `bills-to-pay/${payment_id}`,
      {
        paid: 1,
        paid_user_id: me.id,
        date_paid: new Date(),
        file_id: _file.data.id,
      },
      config,
    );
    toast.success("Pagamento confirmado com sucesso!");
    setReload(!reload);
    closeModal();
    setloading(false);
  };

  const closeModal = () => {
    setfilePayment([]);
    closeModalProps();
  };

  return (
    <Modal size="lg" show={show} onHide={closeModal} centered>
      <Modal.Header>
        <div as="label" className="d-flex w-100">
          <h2 className="page-title">Confirmar Pagamento</h2>
        </div>
        <button className={styles.closeModal} onClick={closeModal}>
          <IcX />
        </button>
      </Modal.Header>
      <Form>
        <Modal.Body>
          <Row>
            <Col>
              <p className="mb-1">Comprovante do Pagamento:</p>
              <File
                file={filePayment[0]}
                getRootProps={getRootPropsfileRG}
                getInputProps={getInputPropsfileRG}
                title="Comprovante do Pagamento"
                noPreview={true}
              />
            </Col>
          </Row>
        </Modal.Body>

        <Modal.Footer>
          <Button color="primary" onClick={confirmPayment} loading={loading}>
            Confirmar Pagamento
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
}
